export const APPLY_FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSfncdmdim2ts1fJd_J8eJEk-A-zuVCwChq9xwJ4MZRxAlw7vg/viewform';